var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","label":"Cell","items":_vm.cells,"prepend-inner-icon":"mdi-crosshairs"},model:{value:(_vm.cell),callback:function ($$v) {_vm.cell=$$v},expression:"cell"}})
}
var staticRenderFns = []

export { render, staticRenderFns }